import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { doc, setDoc, collection } from 'firebase/firestore';
import './BookingPage.css';

const BookingPage = () => {
  const { state } = useLocation();
  const roomTitle = state?.roomTitle || ''; 
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [guests, setGuests] = useState('');
  const [children, setChildren] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !mobile || !guests) {
      setError('Please fill all the fields!');
      return;
    }

    try {
      const bookingRef = doc(collection(db, 'Bookings'));
      await setDoc(bookingRef, {
        roomTitle,
        name,
        email,
        mobile,
        guests,
        children,
        timestamp: new Date(),
      });

      navigate('/');
    } catch (error) {
      setError('Error booking the room. Please try again.');
    }
  };

  return (
    <div className="bookingPage">
      <h1 className="bookingPageTitle">Book Your Stay - {roomTitle}</h1>

      {error && <p className="error">{error}</p>}

      <form onSubmit={handleSubmit} className="bookingForm">
        <div className="formGroup">
          <label>Room Title</label>
          <input
            type="text"
            value={roomTitle}
            disabled
          />
        </div>

        <div className="formGroup">
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="formGroup">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="formGroup">
          <label>Mobile Number</label>
          <input
            type="text"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
        </div>

        <div className="formGroup">
          <label>Number of Guests</label>
          <input
            type="number"
            value={guests}
            onChange={(e) => setGuests(e.target.value)}
            required
          />
        </div>

        <div className="formGroup">
          <label>Number of Children</label>
          <input
            type="number"
            value={children}
            onChange={(e) => setChildren(e.target.value)}
          />
        </div>

        <button type="submit" className="submitButton">Confirm Booking</button>
      </form>
    </div>
  );
};

export default BookingPage;
